export const DOCUMENTS_QUERY = '/documents/list';
export const ORGANISATION_DOCUMENTS_QUERY = '/documents/organisation';
